/**
 * @fileoverview As telas sem login: entrar, criar conta, esqueci a senha, nova
 * senha e confirmar o e-mail. Nelas os contextos globais não pedem dados e a
 * API não tenta renovar a sessão. A de confirmar o e-mail também abre com a
 * sessão aberta (o link pode ser clicado logado): nela, a sessão guardada fica.
 */

export const PUBLIC_PAGES = ["/login", "/signup", "/forgot-password", "/reset-password", "/verify-email"];

// Onde a sessão guardada é descartada ao abrir: todas, menos a confirmação do e-mail.
const SESSION_FREE_PAGES = PUBLIC_PAGES.filter((page) => page !== "/verify-email");

const matches = (pages, pathname) => pages.some((page) => pathname === page || pathname.startsWith(`${page}/`));

export const isPublicPage = (pathname = window.location.pathname) => matches(PUBLIC_PAGES, pathname);

export const isSessionFreePage = (pathname = window.location.pathname) => matches(SESSION_FREE_PAGES, pathname);
